import React, {useState} from 'react';
import {ReactComponent as EyeIcon} from 'assets/svgs/common/eye.svg';
import './style.scss';

const PasswordInput = ({onChange, value, label}) => {
  const [type, setType] = useState(false);
  return (
    <div className="form-group password-container">
      <EyeIcon
        className="eye-icon pointer"
        height={15}
        onClick={() => setType(!type)}
      />
      <label htmlFor="name">{label}</label>
      <input
        id="name"
        type={type ? 'text' : 'password'}
        className="form-control"
        value={value}
        onChange={onChange}
        placeholder={label}
      />
    </div>
  );
};

export default PasswordInput;
